const megaMenus = document.querySelectorAll('[data-ls-mega-menu]');

function setMegaMenuImage(menu, trigger) {
  const image = menu.querySelector('[data-ls-mega-media-image]');
  const link = menu.querySelector('[data-ls-mega-media-link]');
  const triggers = menu.querySelectorAll('[data-ls-mega-image-src]');

  if (!(image instanceof HTMLImageElement)) return;

  triggers.forEach((item) => {
    item.classList.toggle('ls-mega-menu__category-link--active', item === trigger);
  });

  const src = trigger?.dataset.lsMegaImageSrc || image.dataset.lsMegaDefaultSrc;
  const srcset = trigger?.dataset.lsMegaImageSrcset || image.dataset.lsMegaDefaultSrcset || '';
  const alt = trigger?.dataset.lsMegaImageAlt || image.dataset.lsMegaDefaultAlt || '';
  const href = trigger?.dataset.lsMegaImageHref || image.dataset.lsMegaDefaultHref;

  if (src) image.src = src;
  if (srcset) {
    image.srcset = srcset;
  } else {
    image.removeAttribute('srcset');
  }
  image.alt = alt;

  if (link instanceof HTMLAnchorElement && href) {
    link.href = href;
  }
}

megaMenus.forEach((menu) => {
  const triggers = menu.querySelectorAll('[data-ls-mega-image-src]');

  triggers.forEach((trigger) => {
    trigger.addEventListener('pointerenter', () => setMegaMenuImage(menu, trigger));
    trigger.addEventListener('focus', () => setMegaMenuImage(menu, trigger));
  });

  menu.addEventListener('pointerleave', () => setMegaMenuImage(menu));
});
